import { render, staticRenderFns } from "./OrderNumberTile.vue?vue&type=template&id=37e63b00&scoped=true"
import script from "./OrderNumberTile.vue?vue&type=script&lang=js"
export * from "./OrderNumberTile.vue?vue&type=script&lang=js"
import style0 from "./OrderNumberTile.vue?vue&type=style&index=0&id=37e63b00&prod&scoped=true&lang=css"
import style1 from "./OrderNumberTile.vue?vue&type=style&index=1&id=37e63b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e63b00",
  null
  
)

export default component.exports